/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Target_Group_HelpInputs */



/**
* | output |
* | --- |
* | "The target group is used to populate the target events for translation." |
*
* @param {Translation_Merge_Target_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_target_group_help = /** @type {((inputs?: Translation_Merge_Target_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Target_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le groupe cible est utilise pour remplir les evenements cibles pour la traduction.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Zielgruppe dient dazu, die Zielereignisse für die Übersetzung zu ermitteln.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il gruppo target viene utilizzato per popolare gli eventi target per la traduzione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевая группа используется для заполнения целевых событий, подлежащих переводу.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El grupo de destino se utiliza para completar los eventos de destino para la traducción.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标群体用于填充要翻译的目标事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ターゲット グループは、翻訳のターゲット イベントを入力するために使用されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद के लिए लक्षित घटनाओं को भरने के लिए लक्षित समूह का उपयोग किया जाता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O grupo-alvo é usado para preencher os eventos-alvo para tradução.")
	return /** @type {LocalizedString} */ ("The target group is used to populate the target events for translation.")
});